var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import DataField from "./DataField.js";
import DateHelper from "../../helper/DateHelper.js";
class DateDataField extends DataField {
  static get prototypeProperties() {
    return {
      /**
       * The format of the date field.
       *
       * See {@link Core.helper.DateHelper} for details.
       * @config {String} format
       * @default DateHelper.defaultFormat
       */
      format: null
    };
  }
  convert(value) {
    if (value == null) {
      if (!this.nullable) {
        value = this.nullValue;
      }
    } else if (value === "now") {
      value = /* @__PURE__ */ new Date();
    } else if (!(value instanceof Date)) {
      const rawValue = value;
      value = DateHelper.parse(value, this.format || DateHelper.defaultParseFormat);
      if (!value || isNaN(value)) {
        value = void 0;
        if (rawValue !== "") {
          console.warn(`Date parsing failed for "${this.name}" field, input: ${JSON.stringify(rawValue)}. ${this.format ? `Expected format: ${this.format}.` : `You should configure your Model field with a "format" to specify how dates should be parsed. See docs for DateDataField here: https:@bryntum/core-thin/lib/data/field/DateDataField, and see https:@bryntum/core-thin/lib/helper/DateHelper for the different formats.`}"`);
        }
      }
    }
    return value;
  }
  serialize(value) {
    if (value instanceof Date) {
      value = DateHelper.format(value, this.format || DateHelper.defaultFormat);
    }
    return value;
  }
  printValue(value) {
    return DateHelper.format(value, this.format || DateHelper.defaultFormat);
  }
}
__publicField(DateDataField, "$name", "DateDataField");
__publicField(DateDataField, "type", "date");
__publicField(DateDataField, "dataConstructor", Date);
DateDataField.initClass();
DateDataField._$name = "DateDataField";
export {
  DateDataField as default
};
